import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import Button from '../Button'

const SignedInBlock = ({
  handleLogout,
  gotoDashboard
}) => (
  <div className="flex mt-8 border-b pb-8">
    <div className="flex-grow">
      <h5 className="uppercase text-grey tracking-wide-2xl">
        <FormattedMessage id="booking.amountForm.signedInBlock.category" defaultMessage="Logged in" />
      </h5>
      <h2 className="mb-4 md:w-1/2 mt-5">
        <FormattedMessage id="booking.amountForm.signedInBlock.header" defaultMessage="You are already signed in" />
      </h2>
      <button type="button" onClick={handleLogout} className="whitespace-no-wrap font-bold text-grass underline mr-6 uppercase leading-normal tracking-wide">
        <FormattedMessage id="booking.amountForm.signedInBlock.signout" defaultMessage="Sign out" />
      </button> 
      <div className="flex justify-end">
        <Button onClick={gotoDashboard} className="bg-grass">
          <FormattedMessage id="booking.amountForm.signedInBlock.myBookings" defaultMessage="My bookings" />
        </Button>
      </div>
    </div>
  </div>
)
  
SignedInBlock.propTypes = {
  handleLogout: PropTypes.func.isRequired,
  gotoDashboard: PropTypes.func.isRequired
}

export default SignedInBlock